(function () {
	/**
	 * 要素が空かどうかを判定する
	 * @param {HTMLElement} element
	 * @returns {boolean}
	 */
	function isEmptyElement(element) {
		return !element || element.textContent.trim() === "";
	}

	/**
	 * cf_n_tags の空要素を削除する
	 */
	function removeEmptyTagElements() {
		document.querySelectorAll("span.cf_n_tags").forEach(function (tag) {
			if (!tag || tag.children.length === 0 || tag.textContent.trim() === "") {
				tag.remove();
			}
		});
		const tagWrap = document.querySelector('.js-detail-tags');
		if(tagWrap) {
			tagWrap.classList.add('is-visible');
		}
	}

	/**
	 * タグ一覧ラッパーが空になった場合に削除する
	 */
	function removeEmptyTagWrappers() {
		document.querySelectorAll("li.cf_n_tags").forEach(function (wrapper) {
			if (
				!wrapper ||
				wrapper.children.length === 0 ||
				wrapper.textContent.trim() === ""
			) {
				wrapper.remove();
			}
		});
	}

	function removeEmptyStoriesTagWrappers() {
		document.querySelectorAll("span.js-category").forEach(function (wrapper) {
			if (
				!wrapper ||
				wrapper.children.length === 0 ||
				wrapper.textContent.trim() === ""
			) {
				wrapper.remove();
			}
		});
	}

	function removeEmptyStoriesHashTagWrappers() {
		document.querySelectorAll("span.js-hashtag").forEach(function (wrapper) {
			if (
				!wrapper ||
				wrapper.children.length === 0 ||
				wrapper.textContent.trim() === "#" ||
				wrapper.textContent.trim() === ""
			) {
				wrapper.remove();
			}
		});
	}

	/**
	 * 初期化処理
	 */
	function init() {
		removeEmptyTagElements();
		removeEmptyTagWrappers();
		removeEmptyStoriesTagWrappers();
		removeEmptyStoriesHashTagWrappers();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();

// <詳細ページ>右クリック禁止フラグ
(function(){
	const statusEl = document.querySelector('.js-img-status');
	if (!statusEl) return;

	// 許可する：1 許可しない：0
	if(statusEl.textContent.trim() === '0') {
		document.addEventListener('contextmenu', function(e) {
			e.preventDefault();
		});
	}
})();

// <一覧ページ>右クリック禁止フラグ
(function(){
	const statusEls = document.querySelectorAll('.js-list-img-status');
	if (!statusEls.length) return;

	// 許可する：1 許可しない：0
	statusEls.forEach(function(el) {
		if (el.textContent.trim() !== '0') return;
		const item = el.closest('.mod-newsList03-item');
		if (!item) return;
		item.addEventListener('contextmenu', function(e) {
			e.preventDefault();
		});
	});
})();